import {useEffect} from 'react'
import {useParams} from 'react-router'
import TabsDefault from '../../../../components/ui/TabsDefault'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {getBreadCrumbs} from '../../breadcrumbs'
import RedeemptionsInfo from './RedeemptionInfo'


const RedemptionsDetailPage = () => {
  const {id} = useParams<{id: string}>()

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])
  

  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Redemption Management</p>
          </div>
        </div>
        <TabsDefault
          tabs={['Redemption Detail', ]}
          contents={[<RedeemptionsInfo id={id}  />]}
        />
       
       
      </div>
    </>
  )
}

const RedemptionsDetailWrapper = () => {
  const {id} = useParams<{id: string}>()
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs(`/redeemptionsdetail/${id}`)}>Detail Redemption</PageTitle>
      <RedemptionsDetailPage />
    </>
  )
}

export default RedemptionsDetailWrapper